import {Carousel} from '@mantine/carousel';
import {Text} from '@mantine/core';
import {useState} from 'react';
import type {
  InterviewType,
  InterviewsType,
} from '../../../../../core/entities/companyDetail/schema';
import {useMediaQuery} from '../../../../../shared/services/useMediaQuery';
import {InterviewModal} from './InterviewModal';

type Props = {
  companyName: string;
  interviews: InterviewsType;
};

export const CompanyInterviews: React.FC<Props> = ({
  companyName,
  interviews,
}) => {
  const {isPC} = useMediaQuery();
  const withControls = !isPC;
  const withIndicators = !isPC;
  const [openedInterview, setOpenedInterview] = useState<
    InterviewType | undefined
  >(undefined);
  const [nextInterviewIndex, setNextInterviewIndex] = useState<
    number | undefined
  >(undefined);
  const hasNextPage =
    interviews.length > 0 ? interviews.length !== nextInterviewIndex : false;

  return (
    <>
      <div className="mt-8">
        <Carousel
          slideSize="272px"
          slideGap="md"
          align="start"
          controlsOffset="xs"
          withControls={withControls}
          slidesToScroll={1}
          withIndicators={withIndicators}
        >
          {interviews.map((interview, i: number) => {
            return (
              <Carousel.Slide
                key={i}
                className="p-16 bg-white rounded-16 mr-24"
              >
                <img
                  src={interview.headshotURL}
                  alt={`${companyName}の社員インタビュー`}
                  className="w-[240px] h-[240px]"
                />
                <p className="text-base text-black-2 mt-16">
                  {interview.yearsOfEmployment}
                </p>
                <p className="text-md font-bold mt-4">
                  {interview.intervieweeName}
                </p>
                <p className="text-base text-black-2 mt-4 line-clamp-1">
                  {interview.department}
                </p>
                <button
                  className="my-12 px-16 py-12 rounded-full bg-primary flex items-center justify-center mx-auto"
                  onClick={() => {
                    setNextInterviewIndex(i + 1);
                    setOpenedInterview(interview);
                  }}
                >
                  <Text className="text-white text-md font-bold">
                    このインタビューを読む
                  </Text>
                </button>
              </Carousel.Slide>
            );
          })}
        </Carousel>
      </div>
      {openedInterview ? (
        <InterviewModal
          opened={Boolean(openedInterview)}
          onClose={() => {
            setOpenedInterview(undefined);
          }}
          interview={openedInterview}
          onPressNextPage={() => {
            if (nextInterviewIndex) {
              const nextInterview = interviews[nextInterviewIndex];
              setOpenedInterview(undefined);
              setTimeout(() => {
                setOpenedInterview(nextInterview);
              }, 10);
              setNextInterviewIndex(nextInterviewIndex + 1);
            }
          }}
          hasNextPage={hasNextPage}
        />
      ) : null}
    </>
  );
};
